import { cn } from '@tripleten/cn';

export const cnPageInternalLogin = cn('page-internal-login');
